import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import Iconify from '../iconify';
import { GetClient, PostClientBackgroundInfo } from '../services/httpServices';

import styled from '@emotion/styled';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const BackgroundInfo = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState({});
  const [isTuberculosis, setIsTuberculosis] = useState(false);
  const [livedBeyondValidity, setLivedBeyondValidity] = useState(false);
  const [refusedAddToCanda, setRefusedAddToCanda] = useState(false);
  const [convictedInCriminalAct, setConvictedInCriminalAct] = useState(false);
  const [servedInArmdForces, setServedInArmdForces] = useState(false);
  const [memberOfOrgCriminalAct, setMemberOfOrgCriminalAct] = useState(false);
  const [witnessedTreatmentOfPrisoners, setWitnessedTreatmentOfPrisoners] = useState(false);

  const tuberculosisDetailsRef = useRef('');
  const livedBeyondValidityDetailsRef = useRef('');
  const refusedDetailsRef = useRef('');
  const criminalActivityDetailsRef = useRef('');
  const servedInArmdForceDetailsRef = useRef('');
  const orgDetailedExplantionRef = useRef('');
  const treatmentDetailsRef = useRef('');

  const fetchClient = async (event) => {
    const client = await GetClient(props.id);
    setIsTuberculosis(client?.clientBackgroundInfos[0]?.isTuberculosis);
    setLivedBeyondValidity(client?.clientBackgroundInfos[0]?.livedBeyondValidity);
    setRefusedAddToCanda(client?.clientBackgroundInfos[0]?.refusedAddToCanda);
    setConvictedInCriminalAct(client?.clientBackgroundInfos[0]?.convictedInCriminalAct);
    setServedInArmdForces(client?.clientBackgroundInfos[0]?.servedInArmdForces);
    setMemberOfOrgCriminalAct(client?.clientBackgroundInfos[0]?.memberOfOrgCriminalAct);
    setServedInArmdForces(client?.clientBackgroundInfos[0]?.servedInArmdForces);
    setWitnessedTreatmentOfPrisoners(client?.clientBackgroundInfos[0]?.witnessedTreatmentOfPrisoners);
    //console.log('client:', client);
    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);
  // #endregion Refs

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: props.id,
      isTuberculosis: isTuberculosis,
      tuberculosisDetails: tuberculosisDetailsRef.current.value,
      livedBeyondValidity: livedBeyondValidity,
      livedBeyondValidityDetails: livedBeyondValidityDetailsRef.current.value,
      refusedAddToCanda: refusedAddToCanda,
      refusedDetails: refusedDetailsRef.current.value,
      convictedInCriminalAct: convictedInCriminalAct,
      criminalActivityDetails: criminalActivityDetailsRef.current.value,
      servedInArmdForces: servedInArmdForces,
      servedInArmdForceDetails: servedInArmdForceDetailsRef.current.value,
      memberOfOrgCriminalAct: memberOfOrgCriminalAct,
      orgDetailedExplantion: orgDetailedExplantionRef.current.value,
      witnessedTreatmentOfPrisoners: witnessedTreatmentOfPrisoners,
      treatmentDetails: treatmentDetailsRef.current.value,
    };

    //console.log(payload);
    let response = await PostClientBackgroundInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientBackgroundInfos[0] = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const handleChangeIsTuberculosis = (event) => {
    event.target.value == 'true' ? setIsTuberculosis(true) : setIsTuberculosis(false);
    if (event.target.value == 'true') {
      tuberculosisDetailsRef.current.value = client.clientBackgroundInfos[0]?.tuberculosisDetails;
    } else {
      tuberculosisDetailsRef.current.value = '';
    }
  };

  const handleChangeLivedBeyondValidity = (event) => {
    event.target.value == 'true' ? setLivedBeyondValidity(true) : setLivedBeyondValidity(false);
    if (event.target.value == 'true') {
      livedBeyondValidityDetailsRef.current.value = client.clientBackgroundInfos[0]?.livedBeyondValidityDetails;
    } else {
      livedBeyondValidityDetailsRef.current.value = '';
    }
  };

  const handleChangeRefusedAddToCanda = (event) => {
    event.target.value == 'true' ? setRefusedAddToCanda(true) : setRefusedAddToCanda(false);
    if (event.target.value == 'true') {
      refusedDetailsRef.current.value = client.clientBackgroundInfos[0]?.refusedDetails;
    } else {
      refusedDetailsRef.current.value = '';
    }
  };

  const handleChangeConvictedInCriminalAct = (event) => {
    event.target.value == 'true' ? setConvictedInCriminalAct(true) : setConvictedInCriminalAct(false);
    if (event.target.value == 'true') {
      criminalActivityDetailsRef.current.value = client.clientBackgroundInfos[0]?.criminalActivityDetails;
    } else {
      criminalActivityDetailsRef.current.value = '';
    }
  };
  const handleChangeServedInArmdForce = (event) => {
    event.target.value == 'true' ? setServedInArmdForces(true) : setServedInArmdForces(false);
    if (event.target.value == 'true') {
      servedInArmdForceDetailsRef.current.value = client.clientBackgroundInfos[0]?.servedInArmdForceDetails;
    } else {
      servedInArmdForceDetailsRef.current.value = '';
    }
  };

  const handleChangeMemberOfOrgCriminalAct = (event) => {
    event.target.value == 'true' ? setMemberOfOrgCriminalAct(true) : setMemberOfOrgCriminalAct(false);
    if (event.target.value == 'true') {
      orgDetailedExplantionRef.current.value = client.clientBackgroundInfos[0]?.orgDetailedExplantion;
    } else {
      orgDetailedExplantionRef.current.value = '';
    }
  };
  const handleChangeWitnessedTreatment = (event) => {
    event.target.value == 'true' ? setWitnessedTreatmentOfPrisoners(true) : setWitnessedTreatmentOfPrisoners(false);
    if (event.target.value == 'true') {
      treatmentDetailsRef.current.value = client.clientBackgroundInfos[0]?.treatmentDetails;
    } else {
      treatmentDetailsRef.current.value = '';
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you or any of your family members ever had or been in contact with tuberculosis within past
                        2 years?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={isTuberculosis}
                        onChange={handleChangeIsTuberculosis}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give a detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        required
                        label="Tuberculosis Details"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.tuberculosisDetails}
                        disabled={!isTuberculosis}
                        inputRef={tuberculosisDetailsRef}
                      />
                    </Item>
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you remained beyond the validity of your status, studied or worked without authorization in
                        Canada?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={livedBeyondValidity}
                        onChange={handleChangeLivedBeyondValidity}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give a detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        required
                        label="Lived Beyond Validity Details"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.livedBeyondValidityDetails}
                        disabled={!livedBeyondValidity}
                        inputRef={livedBeyondValidityDetailsRef}
                      />
                    </Item>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you ever been refused admission to Canada or any other Country?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={refusedAddToCanda}
                        onChange={handleChangeRefusedAddToCanda}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give a detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        required
                        label="Refused Details"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.refusedDetails}
                        disabled={!refusedAddToCanda}
                        inputRef={refusedDetailsRef}
                      />
                    </Item>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you ever been arrested for, or been charged with or convicted of any criminal offensesin
                        any country including Canada?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={convictedInCriminalAct}
                        onChange={handleChangeConvictedInCriminalAct}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give a detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        required
                        label="Details of criminal offenses"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.criminalActivityDetails}
                        disabled={!convictedInCriminalAct}
                        inputRef={criminalActivityDetailsRef}
                      />
                    </Item>
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Did you serve in the military or any security, or police force in the past?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={servedInArmdForces}
                        onChange={handleChangeServedInArmdForce}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        required
                        label="Details of served in Armed Force"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.servedInArmdForceDetails}
                        disabled={!servedInArmdForces}
                        inputRef={servedInArmdForceDetailsRef}
                      />
                    </Item>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you ever been a member of any organization involved in any criminal activity?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={memberOfOrgCriminalAct}
                        onChange={handleChangeMemberOfOrgCriminalAct}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        required
                        label="Details of Member Of Organinzation"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.orgDetailedExplantion}
                        disabled={!memberOfOrgCriminalAct}
                        inputRef={orgDetailedExplantionRef}
                      />
                    </Item>
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Have you ever witnessed or participated in the ill treatment of prisoners or civilians?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={witnessedTreatmentOfPrisoners}
                        onChange={handleChangeWitnessedTreatment}
                        row
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={6}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; please give detailed explanation
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Details of ill treatment of prisoners"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        defaultValue={client.clientBackgroundInfos[0]?.treatmentDetails}
                        disabled={!witnessedTreatmentOfPrisoners}
                        inputRef={treatmentDetailsRef}
                      />
                    </Item>
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default BackgroundInfo;
